export default __webpack_public_path__ + "static/media/pexels-anna-shvets-3844581.365bbafa.jpg";